<form
    class="flex-column-with-footer flex-column-with-form with-bottom-spacing"
    [formGroup]="emailForm"
    (ngSubmit)="submitRequest()">
    <div>
        <ng-content></ng-content>
    </div>

    @if (errors) {
        <div class="ion-margin-bottom">
            <lib-error-card [errors]="errors" />
        </div>
    }

    <lib-input
        [form]="emailForm"
        controlName="email"
        [ngClass]="errors ? '' : 'margin-top-xl'"
        label="Email"
        placeholder="Enter email"
        name="email"
        type="email"
        [ionItemWrap]="false"
        (onInputEvent)="onInput()" />

    <lib-button type="submit" [expand]="true" [disabled]="!emailForm.valid">Send</lib-button>
</form>
